export const ApplyFilterDatasource = (_filter: any, _filterValue: any, _dataRow: any): boolean => {
    if (_dataRow !== undefined && _dataRow[_filter.DATASOURCE_COLUMN] !== undefined && _filter.TYPE_OPERANDE !== undefined) {
        switch(_filter.TYPE_OPERANDE) {
            case 'gt': return parseFloat(_dataRow[_filter.DATASOURCE_COLUMN]) > parseFloat(_filterValue);
            case 'gte': return parseFloat(_dataRow[_filter.DATASOURCE_COLUMN]) >= parseFloat(_filterValue);
            case 'lt': return parseFloat(_dataRow[_filter.DATASOURCE_COLUMN]) < parseFloat(_filterValue);
            case 'lte': return parseFloat(_dataRow[_filter.DATASOURCE_COLUMN]) <= parseFloat(_filterValue);
            case 'ne': return _dataRow[_filter.DATASOURCE_COLUMN] != _filterValue;
            case 'empty': return !_dataRow[_filter.DATASOURCE_COLUMN] || _dataRow[_filter.DATASOURCE_COLUMN].length == 0;
            case 'not_empty': return !!_dataRow[_filter.DATASOURCE_COLUMN] && _dataRow[_filter.DATASOURCE_COLUMN].length > 0;

            case 'eq':
            default:
                return _dataRow[_filter.DATASOURCE_COLUMN] == _filterValue;
        }
    }
    return false;
}